module.exports = __webpack_public_path__ + "img/icon_kehu_09.de3a1fa9.png";